import { GraphicPaymentType } from '../models';

const ALL_TYPES: GraphicPaymentType['types'][number]['type'][] = ['MONTHLY_PAYMENT', 'PREPAYMENT'];

const initialTypeObj = (type: 'MONTHLY_PAYMENT' | 'PREPAYMENT') => ({
  total: 0,
  currencies: {
    UZS: 0,
    USD: 0
  },
  type
});

export const ensureAllTypesExist = (types: GraphicPaymentType['types'] = []) => {
  const existingTypes = types.map(t => t.type);
  const missingTypes = ALL_TYPES.filter(t => !existingTypes.includes(t));

  const filledTypes = [...types, ...missingTypes.map(missingType => initialTypeObj(missingType))];

  return filledTypes;
};
